/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MfaMethod } from './MfaMethod';
import {
    MfaMethodFromJSON,
    MfaMethodFromJSONTyped,
    MfaMethodToJSON,
} from './MfaMethod';

/**
 * 
 * @export
 * @interface UpdateOrganizationMfaSettingsRequest
 */
export interface UpdateOrganizationMfaSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationMfaSettingsRequest
     */
    mfa_enabled: boolean;
    /**
     * 
     * @type {Array<MfaMethod>}
     * @memberof UpdateOrganizationMfaSettingsRequest
     */
    mfa_allowed_methods: Array<MfaMethod>;
}

/**
 * Check if a given object implements the UpdateOrganizationMfaSettingsRequest interface.
 */
export function instanceOfUpdateOrganizationMfaSettingsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mfa_enabled" in value;
    isInstance = isInstance && "mfa_allowed_methods" in value;

    return isInstance;
}

export function UpdateOrganizationMfaSettingsRequestFromJSON(json: any): UpdateOrganizationMfaSettingsRequest {
    return UpdateOrganizationMfaSettingsRequestFromJSONTyped(json, false);
}

export function UpdateOrganizationMfaSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationMfaSettingsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mfa_enabled': json['mfa_enabled'],
        'mfa_allowed_methods': ((json['mfa_allowed_methods'] as Array<any>).map(MfaMethodFromJSON)),
    };
}

export function UpdateOrganizationMfaSettingsRequestToJSON(value?: UpdateOrganizationMfaSettingsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mfa_enabled': value.mfa_enabled,
        'mfa_allowed_methods': ((value.mfa_allowed_methods as Array<any>).map(MfaMethodToJSON)),
    };
}

